<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('samples.water_add_element') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.symbol') }}:</strong>
                        </h6>
                        {{ rowData.symbol }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td
                        :style="'background-color: ' + rowData.color"
                        scope="row"
                      >
                        <h6>
                          <strong>{{ $t('common_words.color') }}:</strong>
                        </h6>
                        {{ rowData.color }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ rowData.description }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('climate.assimilable_form') }}</strong>
                        </h6>
                        {{ rowData.assimilable_form }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.unit') }}:</strong>
                        </h6>
                        {{ rowData.unit }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog
            v-if="isCreate()"
            :title="title"
            :visible.sync="modals.create"
          >
            <form>
              <div class="row">
                <div class="col-12">
                  <div class="form-group has-label">
                    <label class="text-transform-none"
                      >{{ $t('common_words.select_companies') }} *</label
                    >
                    <br />
                    <el-select
                      @change="
                        selectAllFromSelect('model.businesses_id', businesses)
                      "
                      clearable
                      multiple
                      collapse-tags
                      class="select-primary custom-width-select nut-rels shadow-sm"
                      size="large"
                      v-model="model.businesses_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      filterable
                    >
                      <el-option
                        v-for="option in businesses"
                        class="select-primary selected-all"
                        :value="option.id"
                        :label="option.name"
                        :key="option.name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-4">
                  <fg-input
                    ref="description"
                    type="text"
                    :label="`${$t('common_words.description')} *`"
                    v-model="model.description"
                    v-validate="modelValidations.description"
                    name="common_words.description"
                    :error="getError('common_words.description', true)"
                  >
                  </fg-input>
                </div>
                <div class="col-12 col-sm-4">
                  <fg-input
                    ref="symbol"
                    type="text"
                    :label="`${$t('common_words.symbol')} *`"
                    v-model="model.symbol"
                    v-validate="modelValidations.symbol"
                    name="common_words.symbol"
                    :error="getError('common_words.symbol', true)"
                  >
                  </fg-input>
                </div>
                <div class="col-12 col-sm-4">
                  <fg-input
                    ref="assimilable_form"
                    type="text"
                    :label="`${$t('climate.assimilable_form')} *`"
                    v-model="model.assimilable_form"
                    v-validate="modelValidations.assimilable_form"
                    name="climate.assimilable_form"
                    :error="getError('climate.assimilable_form', true)"
                  >
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-4">
                  <fg-input
                    ref="unit"
                    type="text"
                    :label="`${$t('common_words.unit')} *`"
                    v-model="model.unit"
                    v-validate="modelValidations.unit"
                    name="common_words.unit"
                    :error="getError('common_words.unit', true)"
                  >
                  </fg-input>
                </div>
                <div class="col-12 col-sm-4 form-group has-label">
                  <label>{{ $t('common_words.color') }}: *</label>
                  <sketch-picker
                    :value="colors"
                    @input="updateValue"
                  ></sketch-picker>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :cell-style="handlecellstyle"
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="80"
                align="center"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                min-width="60"
                label="Color"
                align="center"
                :resizable="false"
                :sortable="true"
              >
                <template slot-scope="props">
                  <div class="text">
                    <span style="'mix-blend-mode: difference;'">{{
                      props.row.color
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route: 'waters/nutrients/pdf',
                  name_file: 'nutrientes.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route: 'waters/nutrients/excel',
                  name_file: 'nutrientes.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './waterNutrientsTable';
import moment from 'moment';
import MixinColors from 'src/util/mixinColor';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';
import i18n from 'src/i18n';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      model: {
        symbol: null,
        description: null,
        assimilable_form: null,
        unit: null,
        color: null,
        businesses_id: [],
      },
      modelValidations: {
        symbol: {
          required: true,
        },
        description: {
          required: true,
        },
        assimilable_form: {
          required: true,
        },
        unit: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      businesses: [],
    };
  },
  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  mixins: [
    mixinMasters,
    MixinForm,
    MixinPermissions,
    MixinExport,
    MixinMenu,
    MixinColors,
  ],

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('samples.element_add');
        this.$validator.reset();
        this.model = {
          symbol: null,
          description: null,
          assimilable_form: null,
          unit: null,
          color: this.colors,
          businesses_id: [],
        };
      }

      this.modals[name] = true;
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.model.businesses_id.length == 0) {
            this.highlightItem('nut-rels');
            return false;
          } else {
            this.addEditNutrient();
          }
        }
      });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      this.title = i18n.t('samples.element_edit') + ' ' + row.symbol;
      this.model = Object.assign({}, row);
      this.colors = this.model.color;
      this.model.route = 'waters/nutrients';
      this.errors.clear();
      this.modals['create'] = true;
    },

    handleDelete(index, row) {
      this.model = row;
      SweetAlert.delete(this.model.description).then((result) => {
        if (result.value) this.deleteNutrient();
      });
    },

    handlecellstyle({ row, columnIndex }) {
      if (row.color && columnIndex == 4) {
        return 'background-color: ' + row.color;
      }
    },

    addEditNutrient() {
      this.showHideLoading(true);

      if (this.model.route == 'waters/nutrients') {
        if (this.isUpdate()) {
          Axios.updateMaster(this.model)
            .then((response) => this.modifyTable(1, this.model.id, response))
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        this.model.route = 'waters/nutrients';

        if (this.isCreate()) {
          Axios.saveMaster(this.model)
            .then((response) => this.modifyTable(0, this.model.id, response))
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    deleteNutrient() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'waters/nutrients';
        Axios.destroyMaster(this.model)
          .then((response) => this.modifyTable(2, this.model.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('waters/nutrients')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.model.color = this.colors;
    this.selectedItemOnMenu('waters/nutrients');
  },

  destroyed() {
    this.deselectedItemOnMenu('waters/nutrients');
  },
};
</script>
